<script>
import {UPopover} from 'uloc-vue'
import MenuOptionsItem from '../../../layout/context-menu/context-window-options-item'
import printRecibo from "@/components/pda/print/recibo"
import printNota from "@/components/pda/print/nota"
import termoRetirada from "@/components/pda/print/termoRetirada"
import termoAlienacao from "@/components/pda/print/termoAlienacao"
import autoArrematacao from "@/components/pda/print/autoArrematacao"

export default {
  name: 'BtnEmissoesLote',
  props: ['lote'],
  components: {MenuOptionsItem, UPopover},
  computed: {
  },
  methods: {
    printReciboWindow (lotes) {
      // let route = this.$router.resolve({name: 'print.lote.recibo', params: {id: }})
      window.open(`/#/print/lotes/${this.lote.id}/recibo`, '_blank')
    },
    printReciboComitenteWindow (lotes) {
      // let route = this.$router.resolve({name: 'print.lote.recibo', params: {id: }})
      window.open(`/#/print/lotes/${this.lote.id}/reciboComitente`, '_blank')
    },
    printRecibo: printRecibo,
    printNota: printNota,
    termoRetirada: termoRetirada,
    termoAlienacao: termoAlienacao,
    autoArrematacao: autoArrematacao,
  }
}
</script>

<template>
  <e-btn icon="print" icon-type="fa" icon-style="light" v-if="lote.arremate" align="left" label="Emissão">
    <span class="m-l-md"></span> <u-icon name="chevron-down" type="fa" class="absolute-right m-l m-r-sm text-grey-7" style="font-size: 10px !important;"/>
    <u-popover class="window-context-menu no-border-radius" anchor="bottom left" self="top left">
      <div class="menu_ menu-btn-leilao">
        <ul>
          <menu-options-item icon="file-alt" icon-type="fa" icon-style="light" label="Nota" close @click="printNota([lote], 'unificado')"  />
        </ul>
        <ul>
          <menu-options-item icon="receipt" icon-type="fa" icon-style="light" label-class="text-green" label="Recibo" close @click="printReciboWindow([lote])" />
        </ul>
        <ul>
          <menu-options-item icon="receipt" icon-type="fa" icon-style="light" label="Recibo do Comitente" close @click="printReciboComitenteWindow([lote])" />
        </ul>
        <ul>
          <menu-options-item icon="file-alt" icon-type="fa" icon-style="light" label="Auto Positivo" close @click="autoArrematacao([lote])" />
        </ul>
        <ul>
          <menu-options-item icon="file-alt" icon-type="fa" icon-style="light" label="Termo de Alienação" close @click="termoAlienacao([lote])" />
        </ul>
<!--        <ul>
          <menu-options-item icon="file-alt" icon-type="fa" icon-style="light" label="Certidão de publicação" close />
        </ul>-->
        <slot />
      </div>
    </u-popover>
  </e-btn>
</template>
